import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalibrationService {

  constructor(private http: HttpClient) { }

  GetRecord(
    startDate: String,
    endDate: String,
    customer: String,
    code: String,
    schedulecode: String,
    SubmitPeriodDate: String,
    Token: String,
    InLocation: boolean): Observable<Array<Calibration_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration?token=" + Token
      + "&startDate=" + startDate
      + "&endDate=" + endDate
      + "&customer=" + customer
      + "&code=" + code
      + "&schedulecode=" + schedulecode
      + "&SubmitPeriodDate=" + SubmitPeriodDate
      + "&InLocation=" + InLocation
    ).pipe(
      map(data => {
        return data as Array<Calibration_List_Interface>
      })
    )
  }

  GetSingle(Token: String, id: Number,letterSchedule_id: Number,letter_id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/GetSingle?token=" + Token
      + "&id=" + id
      + "&letterSchedule_id=" + letterSchedule_id
      + "&letter_id=" + letter_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  LockScheduleLetter(Token: String,letterSchedule_id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/LockScheduleLetter?token=" + Token
      + "&letterSchedule_id=" + letterSchedule_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  UnLockScheduleLetter(Token: String,letterSchedule_id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/UnLockScheduleLetter?token=" + Token
      + "&letterSchedule_id=" + letterSchedule_id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  SetCalibrationDetailVisible(Token: String, id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/SetCalibrationDetailVisible?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetInfobyQR(Token: String, qr: String): Observable<General_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/GetInfobyQR?token=" + Token + "&qr=" + qr).pipe(
      map(data => {
        return data as General_Interface
      })
    )
  }

  GetSingleCalibrationDetail(Token: String, id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/GetSingleCalibrationDetail?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }


  GetReception(Token: String, id: number): Observable<Array<Calibration_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/GetReception?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as Array<Calibration_Interface>
      })
    )
  }

  GetLabAddressCustomer(Token: String, id: number): Observable<Array<string>> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/GetLabAddressCustomer?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as Array<string>
      })
    )
  }

  GetDetailCount(Token: String, InLocation: boolean): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/GetDetailCount?token=" + Token + "&InLocation=" + InLocation).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetDetailCountInlocation(Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/GetDetailCountInlocation?token=" + Token).pipe(
        map(data => {
          return data as any
        })
      )
  }


  AddEditCalibration(
    Device: Array<Calibration_Interface>,
    DeviceBehfa: Array<DeviceBehfa_Interface>,
    Files: Array<General_Interface>,
    DscList: Array<string>,
    //LetterRequestCustomer_Device_Detail: Array<Number>,
    letterRequestCustomer_Id: Number,
    LetterRequestSchduleCustomer_Id: Number,
    CustomerId: number,
    Reciver_CustomerId: number,
    Calibration_Form_Id: string,
    InLocation: boolean,
    Reciver_Customer_Dsc: string,
    Dsc: string,
    status: boolean,
    labAdderss: string,
    tavilDahandeh: string,
    MailMessage: Array<General_Interface>,
    Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_Device: Array<any> = []
    var Local_Device_Child: Array<any> = []
    var Local_Device_DeviceBehfa: Array<any> = []
    var Local_Manufacture: Array<any> = []

    var indexer_Manufacture: number = 0




    for (let item of Device) {
      indexer_Manufacture = indexer_Manufacture + 1

      Local_Device.push({
        id: item.id,
        device_id: item.device_id,
        code: item.device_code,
        serial: item.device_serial,
        expiration: Number(item.expiration),
        priority: item.priority,
        priod: item.priod,
        dsc: item.dsc,
        asteghrar: item.asteghrar,
        parent: 0,

        expert_off: item.expert_off,
        status: item.status,

        del: false,
      })


      for (let itemDetail of item.deviceBehfa) {
        Local_Device_DeviceBehfa.push({
          description: itemDetail.description,
          manufacturer: itemDetail.manufacturer,
          model: itemDetail.model,
          codeBEHFA: itemDetail.codeBEHFA,
          certificateNo: itemDetail.certificateNo,
          calDueStr: "",

          Calibration_Detail_id: indexer_Manufacture,
          deviceBehfa_id: itemDetail.id_temp,
          deviceBehfa_history_id: itemDetail.id,
          id: itemDetail.id_main,
        })

      }


      
      for (let itemDetail of item.child) {
        Local_Device_Child.push({
          id: itemDetail.id,
          parent: indexer_Manufacture,
          device_id: itemDetail.device_id,
          code: itemDetail.device_code,
          serial: itemDetail.device_serial,
          expiration: Number(itemDetail.expiration),
          priority: itemDetail.priority,
          priod: itemDetail.priod,
          dsc: itemDetail.dsc,
  
          expert_off: itemDetail.expert_off,
          status: itemDetail.status,
  
          del: false,
        })

      }

    }

    var Customer = {
      id: Number(Calibration_Form_Id),
      Customer_id: CustomerId,
      InLocation: InLocation,
      LetterRequestCustomer_Id: letterRequestCustomer_Id,
      LetterRequestSchduleCustomer_Id: LetterRequestSchduleCustomer_Id,
      Reciver_Customer_id: Reciver_CustomerId,
      Dsc: Dsc,
      labAdderss: labAdderss,
      tavilDahandeh: tavilDahandeh,
      Reciver_Customer_Dsc: Reciver_Customer_Dsc,
      Status: status
    }

    var Local_MailMessage: Array<any> = []
    for (let item of MailMessage) {
      Local_MailMessage.push({
        id: 0,
        mailmessage_id: item.id
      })
    }

    var Local_Files: Array<any> = []
    for (let item of Files) {
      Local_Files.push({
        id: item.id,
        filename: item.title,
        dsc: item.code,
      })
    }

    var Local_Dsc: Array<any> = []
    for (let item of DscList) {
      Local_Dsc.push({
        id: 0,
        calibration_id: 0,
        dsc: item,
      })
    }

    var body = {
      Token: Token,
      model: Customer,
      DeviceBehfa: DeviceBehfa,
      file: Local_Files,
      Calibration_Detail: Local_Device,
      Calibration_Detail_Child: Local_Device_Child,
      //LetterRequestCustomer_Device_Detail: LetterRequestCustomer_Device_Detail,
      Calibration_Detail_MANUFACTURE: Local_Manufacture,
      Device_DeviceBehfa: Local_Device_DeviceBehfa,
      mailMessage: Local_MailMessage,
      dsc: Local_Dsc,
    }

    return this.http.post(environment.BaseUrl + "Daro/Calibration/AddEdit", body, { headers }).pipe(
      map(data => {
        return data
      })
    )

  }




  uploadFile(body, Token: String) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Calibration/Upload?token=" + Token, body).pipe(
      map(data => {

        return data
      })
    )
  }

  uploadFileCertificate(body, id:number, Token: String, filename: String) {

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Calibration/UploadCertificate?token=" + Token
      + "&filename=" + filename
      +"&id=" + id, body).pipe(
      map(data => {

        return data
      })
    )
  }

  DeleteCalibration(id: number, RejectDsc: String, Token: String): Observable<Calibration_List_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Calibration/Delete?id=" + id + "&RejectDsc=" + RejectDsc + "&token=" + Token).pipe(
      map(data => {
        return data as Calibration_List_Interface
      })
    )

  }

  EditExpertCalibration(Token: String, Calibration_Id: Number, Expert_Id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/EditExpertCalibration?token=" + Token + "&calibrationId=" + Calibration_Id + "&expertId=" + Expert_Id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  VisibleKarshnasPrint(id: number,Token: String): Observable<Calibration_List_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Calibration/VisibleKarshnasPrint?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as Calibration_List_Interface
      })
    )

  }


  GetCalibrationDeviceBehfa(Token: String,id:number): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/GetCalibrationDeviceBehfa?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<DeviceBehfa_Interface>
        })
      )
  }

  GetCalibrationDeviceBehfaScan(Token: String,id:number): Observable<Array<DeviceBehfa_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/GetCalibrationDeviceBehfaScan?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<DeviceBehfa_Interface>
        })
      )
  }

  PostCalibrationDeviceBehfaAdd(Token: String,device_id:number,id:number,Dsc: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/PostCalibrationDeviceBehfaAdd?token=" + Token
      + "&device_id=" + device_id
      + "&id=" + id
      + "&Dsc=" + Dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  PostCalibrationDeviceBehfaRemove(Token: String,id:number,Dsc: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/PostCalibrationDeviceBehfaRemove?token=" + Token
      + "&id=" + id
      + "&Dsc=" + Dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  DisplayLinearity(Token: String, id: Number,status: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Calibration/DisplayLinearity?token=" + Token
      + "&id=" + id
      + "&status=" + status).pipe(
      map(data => {
        return data as any
      })
    )
  }



  SubmitCalibrationCertification(Token: String,
    id:number,
    eng:number,
    nabl:number,
    code:string,
    serial:string,
    expiration:number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/SubmitCalibrationCertification?token=" + Token
      + "&id=" + id
      + "&eng=" + eng
      + "&nabl=" + nabl
      + "&code=" + code
      + "&serial=" + serial
      + "&expiration=" + expiration).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetCalibrationRelativeDeviceName(Token: String,
    id:number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/GetCalibrationRelativeDeviceName?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<General_Interface>
        })
      )
  }

  SubmitCalibrationCertificationDevicename(Token: String,
    id:number,
    devicename:string,
    dsc:string): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/SubmitCalibrationCertificationDevicename?token=" + Token
      + "&id=" + id
      + "&devicename=" + devicename
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetCalibrationRelativeDeviceNameDetail(Token: String,id:number): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/GetCalibrationRelativeDeviceNameDetail?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as any
        })
      )
  }

  SubmitCalibrationStatus(Token: String,id:number,dsc:string): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Calibration/SubmitCalibrationStatus?token=" + Token
      + "&id=" + id
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  MergeCalibration(Token: String, id1: Number,id2: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Lab/MergeCalibration?token=" + Token
      + "&id1=" + id1
      + "&id2=" + id2).pipe(
      map(data => {
        return data as any
      })
    )
  }
  
  UnMergeCalibration(Token: String, id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Lab/UnMergeCalibration?token=" + Token
      + "&id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

}
